import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Module } from '../shared/module.model';
import { TYPEMODULE, LoaderService, NotificationService, UtilityService, ErrorService, TYPEMESSAGE } from '../../../../shared/session/index';
import { ModuleService } from '../shared/module.service';

@Component({
    selector: 'app-module-view',
    templateUrl: 'module-view.component.html'
})
export class ModuleViewComponent implements OnInit {
    @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
    @Input() typeModule: TYPEMODULE;
    @Input() titlePage: string;
    @Input() data: any;

    modules: Module;
    msgErrorGet: string;

    constructor(private loaderService: LoaderService,
        private moduleService: ModuleService,
        private notificationService: NotificationService,
        private utilityService: UtilityService) { }

    ngOnInit() {
        this.modules = new Module(0, "", 1, "", true,"", "","", "", "");
        this.msgErrorGet = 'Error al obtener datos';
        this.obtenerModule(this.data.modules.ID);
    }

    private obtenerModule(id: number): void {
        this.loaderService.show();
        this.moduleService.obtenerModule(id)
            .subscribe(res => {
                this.modules = res;
                this.utilityService.setAuditoria(this.modules);
            },
                error => {
                    this.notificationService.error(this.msgErrorGet);
                    throw error;
                },
                () => {
                    this.loaderService.hide();
                });
    }
}
